import React from 'react';

import Headings, { Heading, HeadingConfig } from 'components/Headings';
import Image from 'components/Image';

import { HeaderIcon } from './headerIcons';

export interface IProps {
  icon?: HeaderIcon;
  title: Heading;
  subtitle?: Heading;
  headingConfig?: HeadingConfig;
}

const HeaderWithIcon = ({ headingConfig, icon, title, subtitle }: IProps) => {
  return (
    <div className="HeaderWithIcon flex flex-col">
      {icon && (
        <div className="HeaderWithIcon__iconLogo mx-auto my-6">
          <Image
            src={icon.icon}
            alt={{ id: icon.alt }}
            className="w-full"
            style={{ maxWidth: icon.maxWidth }}
          />
        </div>
      )}

      <Headings title={title} subtitle={subtitle} config={headingConfig} />
    </div>
  );
};

export default HeaderWithIcon;
